'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _keysToValuesResolver = require('../resolvers/keysToValuesResolver');

var _keysToValuesResolver2 = _interopRequireDefault(_keysToValuesResolver);

var _converters = require('../utils/converters');

var _predicate = require('../utils/predicate');

var _transformer = require('./transformer');

var _transformer2 = _interopRequireDefault(_transformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unitlessNumberToLengthTransformer = (0, _transformer2.default)(_predicate.isValidNonZeroNumber, function (value, data, breakpointName) {
  var _keysToValueResolver = (0, _keysToValuesResolver2.default)(['lengthUnit', 'baseFontSize'])(value, data, breakpointName),
      _keysToValueResolver2 = _slicedToArray(_keysToValueResolver, 2),
      lengthUnit = _keysToValueResolver2[0],
      baseFontSize = _keysToValueResolver2[1];

  return (0, _converters.unitlessNumberToDistance)(lengthUnit, baseFontSize)(value);
});

exports.default = unitlessNumberToLengthTransformer;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/transformers/unitlessNumberToLengthTransformer.js
// module id = 678
// module chunks = 168707334958949